module.exports = "<div id=\"loginContainer\" class=\"container newFlow\" style=\"position:absolute;top:0;left:0;width:100%;height:100%;background-image:url(/assets/images/csnswbg-1.jpg);background-color:#ffffff;\">\r\n\t<div style=\"padding-top: 50px;\">\r\n\t\t<span>\r\n            <i class=\"fa fa-spinner fa-spin\"></i>\r\n\t\t</span>   \r\n\t</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.html
// module id = 488
// module chunks = 0